import * as types from "./actionTypes";

export function dispatchActionData(type, data) {
  return { type: type, data: data };
}

//to open Dialog
export function openAlertDialog(data) {
  return function (dispatch) {
    dispatch(dispatchActionData(types.OPEN_ALERT_DIALOG, data));
  };
}
//to close Alert dialog
export function closeAlertDialog() {
  return function (dispatch) {
    dispatch(dispatchActionData(types.CLOSE_ALERT_DIALOG));
  };
}
